import { createElement, createFactory } from 'react';
import { compose, flattenProp, withPropsOnChange, withHandlers } from 'recompose';
import { Field } from 'redux-form';

const enhancedField = withHandlers({
  onChange: ({ onChange, name }) => (event, value) => onChange && onChange(value, name)
})(Field);

const createComponent = compose(
  flattenProp('input'),
  withPropsOnChange(['meta'], ({ meta }) => ({
    error: meta.error
  }))
);

export default BaseComponent => {
  const component = createComponent(BaseComponent);
  return (props) => createElement(enhancedField, { ...props, component });
};
